import { Box, BoxProps } from '@chakra-ui/react';
import { useCallback, useEffect, useRef } from 'react';

const ROTATION_SPEED = -0.07; // degrees per animation-frame

type Props = BoxProps & { rotation?: number; animate?: boolean };

export const NewsletterSubscriptionDecorationShape = ({
  rotation: startRotation,
  animate,
  color,
  ...boxProps
}: Props) => {
  const element = useRef<HTMLDivElement>(null);
  const rotation = useRef(startRotation || 0);
  const animation = useRef<ReturnType<typeof requestAnimationFrame>>();

  const rotate = useCallback(() => {
    rotation.current = (rotation.current + ROTATION_SPEED) % 360;

    if (element.current) {
      element.current.style.backgroundImage = `conic-gradient(
        from ${rotation.current}deg at 50% 50%,
        #0D7EC4 0deg,
        #139EDD 60deg,
        #BBDBFF 114.38deg,
        #FEA514 174.38deg,
        #FF4539 210deg,
        #FF5544 247.5deg,
        #FF6A9A 292.5deg,
        #BBDBFF 317.5deg,
        #BBDBFF 327.5deg,
        #0D7EC4 360deg
      )`;
    }

    animation.current = requestAnimationFrame(rotate);
  }, [element, rotation]);

  useEffect(() => {
    if (!animate || color) return;
    rotate();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return () => cancelAnimationFrame(animation.current!);
  }, [animate, rotate, startRotation, color]);

  return (
    <Box ref={element} borderLeftRadius="full" overflow="hidden" background={color} {...boxProps} />
  );
};
